import React, { useState } from "react";
import PlanosAdicionar from "../PlanosAdicionar";
import PlanosLista from "../PlanosLista";
import { Box } from "@mui/material";

interface PlanosProps {
  token: string;
}

const Planos: React.FC<PlanosProps> = ({ token }) => {
  const [shouldUpdateList, setShouldUpdateList] = useState<boolean>(false);

  const handleUpdateList = () => {
    setShouldUpdateList((prev) => !prev); // Altera o estado para forçar o re-fetch
  };

  return (
    <Box
      sx={{
        padding: 3,
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <PlanosAdicionar token={token} onPlanAdded={handleUpdateList} />
      </Box>
      <Box sx={{ width: "100%" }}>
        <PlanosLista token={token} shouldUpdateList={shouldUpdateList} />
      </Box>
    </Box>
  );
};

export default Planos;
